export default "__VITE_ASSET__BQ5eBu8e__"